import React from "react";
import SpeedMeter from "../SvgIcons/SpeedMeter";

const ProductDetails = ({ details, productType }) => {
  return (
    <div className="flex h-5 items-center gap-3">
      <div className="flex items-center gap-1">
        {details?.totalTravelled && <SpeedMeter className="mr-1 h-4 w-4" />}
        <span className="font-pop text-xs text-cardSecondaryColor">
          {details?.totalTravelled ? `${details?.totalTravelled}km` : ""}
        </span>
      </div>
    </div>
  );
};

export default ProductDetails;
